module.exports = __webpack_public_path__ + "images/benelli30300f3f1a25e8c0dbd23270bd978a11.png";